import { useNavigate } from "react-router-dom";
import WisdomLogo from "../../medias/images/Wisdom logo transparent.png"
import "../landingPage/Landing.css";
import { useState } from "react";

function LandingHeader() {
  const [value, setValue] = useState("default");
  const navigate = useNavigate();

  function handleChange(e) {
    const val = e.target.value;
    setValue(val);
    if (val !== "default") {
      navigate(val);
    }
  }

  return (
    <div className="landing-header">
      <img className="landing-logo" src={WisdomLogo} alt="Wisdom Logo" />
      <div className="landing-header-links">
        <div className="options-box">
          <select className="login-select" value={value} onChange={handleChange}>
            <option value="default">Select a login form</option>
            <option value="/signin">User</option>
            <option value="/applicant-signin">Applicant</option>
          </select>
        </div>
      </div>
    </div>
  );
}

export default LandingHeader;
